import { render } from "./TaskToNumDetail.vue?vue&type=template&id=fbd61d46"
import script from "./TaskToNumDetail.vue?vue&type=script&lang=js"
export * from "./TaskToNumDetail.vue?vue&type=script&lang=js"

import "./TaskToNumDetail.vue?vue&type=style&index=0&id=fbd61d46&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__